// Okta configuration
export const oktaConfig = {
  clientId: '0oa1zjumxb08K20QG1d8',
  issuer: 'https://extsso.cloud.com/oauth2/default',
  redirectUri: 'https://accountselectionpoc.citrix.com/login/callback',
  scopes: ['openid', 'profile', 'email'],
  pkce: true,
  disableHttpsCheck: process.env.NODE_ENV === 'development',
  // Force full page redirect instead of silent authentication
  responseType: ['code'],
  // Disable token auto-renewal to prevent silent authentication
  tokenManager: {
    autoRenew: false,
    autoRemove: true
  }
};

// Okta endpoints
export const oktaEndpoints = {
  workflowUrl: "https://cloudsgext.workflows.okta.com/api/flo/272c8c99b3beab963973db833cc05758/invoke?clientToken=75ff0470286918dc6c4695d89452e946628779d911c353e36b69b308b95b570c",
  citrixRedirectUrl: "https://devazr-citrix.ice.citrix.com/"
};
